import React from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

/**
 *  Prodigy Styled Select List
 *
 *  Supports Large and Small variants
 *  'p-select' or 'p-select-sml'
 *  defaults to large styling
 */
function ProdigySelect(props) {
  const {
    options,
    placeholder = 'Select...',
    className = 'p-select',
    searchable,
    disabled = false,
    onChange,
    value,
    id,
  } = props;

  const prodigySelectStyles = {
    control: provided => ({
      ...provided,
      height: 26,
      minHeight: 26,
    }),
    placeholder: provided => ({
      ...provided,
      fontSize: 12,
      height: 26,
      lineHeight: '26px',
      top: 0,
      transform: 'none',
      WebkitTransform: 'none',
    }),
    singleValue: provided => ({
      ...provided,
      fontSize: 12,
      height: 26,
      lineHeight: '26px',
      top: 0,
      transform: 'none',
      WebkitTransform: 'none',
    }),
    valueContainer: provided => ({
      ...provided,
      height: 26,
      transform: 'none',
      WebkitTransform: 'none',
      cursor: 'pointer',
      position: 'inherit',
    }),
    indicatorsContainer: provided => ({
      ...provided,
      height: 26,
      top: 0,
      transform: 'none',
      WebkitTransform: 'none',
      cursor: 'pointer',
    }),
    input: provided => ({
      ...provided,
      height: 26,
      minHeight: 26,
      fontSize: 12,
      top: 0,
      transform: 'none',
      WebkitTransform: 'none',
    }),
    menu: provided => ({
      ...provided,
      top: 20,
    }),
    option: provided => ({
      ...provided,
      fontSize: 12,
      cursor: 'pointer',
    }),
  };

  return (
    <ReactSelect
      id={id}
      className={className}
      classNamePrefix="prodigy_select_"
      options={options}
      placeholder={placeholder}
      isSearchable={searchable}
      onChange={onChange}
      value={options.find(o => isEqual(o.value, value))}
      isDisabled={disabled}
      clearValue={onChange}
      styles={prodigySelectStyles}
    />
  );
}

ProdigySelect.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  searchable: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.any,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default ProdigySelect;
